// third party
import cx from "classnames";

// anivive
import {
  Checkbox,
  Date,
  Datetime,
  Dropdown,
  Email,
  NumberInput,
  Password,
  Phone,
  RadioList,
  Slider,
  Text,
  Textarea,
  Time,
} from "@anivive/ui";

// types
import { Element } from "@/typedef/forms";

type Props = {
  questions: Element[];
  answers: Record<string, unknown>;
  onChange: (name: string, value: unknown) => void;
  disabled?: boolean;
};

const getComponent = (element: Element) => {
  switch (element.type) {
    case "input":
      switch (element.attr.type) {
        case "text":
          return Text;
        case "number":
          return NumberInput;
        case "email":
          return Email;
        case "phone":
          return Phone;
        case "date":
          return Date;
        case "datetime":
          return Datetime;
        case "password":
          return Password;
        case "slider":
          return Slider;
        case "time":
          return Time;
        default:
      }
    case "textarea":
      return Textarea;
    case "checkbox":
      return Checkbox;
    case "radio":
      return RadioList;
    case "dropdown":
      return Dropdown;
    default:
      return null;
  }
};

export default function Wizard({ questions, answers, onChange, disabled }: Props) {
  const handleOnChange = (name: string, value: unknown) => {
    onChange(name, value);
  };

  return questions.map((element, index) => {
    const Component = getComponent(element);
    const hasOptions =
      element.type === "checkbox" || element.type === "dropdown" || element.type === "radio";

    if (Component) {
      return (
        <div className="mb-4" key={index}>
          <p className="text-style-body1-regular mb-1">{element.text}</p>
          <Component
            className={cx(element.type === "radio" ? "mt-2" : "", "w-100")}
            disabled={disabled}
            name={element._key}
            onChange={(value) => handleOnChange(element._key, value)}
            // @ts-expect-error component is generic
            options={hasOptions ? element.options ?? [] : undefined}
            placeholder={element?.attr?.placeholder}
            required={!element.allowEmpty}
            // @ts-expect-error component is generic
            value={answers[element._key]}
          />
        </div>
      );
    }

    return null;
  });
}
